import { Pipe, PipeTransform } from '@angular/core';
import { TimeFormatPipe } from '../time-format/time-format';

/**
 * Generated class for the TimeFormatFromNowPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'timeFormatFromNow',
})
export class TimeFormatFromNowPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: number, ...args) {
    if (typeof value === 'number') {
      //如果是 秒 为单位就变为毫秒
      if(String(value).length == 10 || String(value).length==11) value*=1000;
      let date = new Date(value);
      let now = new Date().getTime();

      let fmt = '';
      if (Math.abs(value - now) <= 24 * 60 * 60 * 1000) {
        if (date.getDay() == new Date().getDay()) {
          fmt = '今天';
        } else if (value < now) {
          fmt = '昨天';
        } else {
          fmt = '明天';
        }
      } else if (Math.abs(value - now) <= 3 * 24 * 60 * 60 * 1000) {
        if (date.getDay() == new Date(now - 24 * 60 * 60 * 1000).getDay()) {
          fmt = '昨天';
        } else if (
          date.getDay() == new Date(now + 24 * 60 * 60 * 1000).getDay()
        ) {
          fmt = '明天';
        } else if (
          date.getDay() == new Date(now - 2 * 24 * 60 * 60 * 1000).getDay()
        ) {
          fmt = '前天';
        } else if (
          date.getDay() == new Date(now + 2 * 24 * 60 * 60 * 1000).getDay()
        ) {
          fmt = '后天';
        }
      } else if (
        date.getUTCFullYear() == new Date(now).getUTCFullYear()
      ) {
        fmt = new TimeFormatPipe().transform(value, 'MM-dd');
      } else {
        fmt = new TimeFormatPipe().transform(value, 'yy-MM-dd');
      }

      if (date.getUTCFullYear() == new Date(now).getUTCFullYear()) {
        fmt = fmt + ' ' + new TimeFormatPipe().transform(value, 'hh:mm');
      }
      return fmt
    } else return '';
  }
}



// WEBPACK FOOTER //
// ./src/pipes/time-format-from-now/time-format-from-now.ts